import script from "./Accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=44b7fad0&lang=scss"

const __exports__ = script;

export default __exports__